import { useCallback } from 'react';

import { useUpdateDealItemField } from '@/lib/hooks/useUpdateDealItemField';

/**
 * Toggles the "TVA sur marge" flag of a deal item, optimistically.
 *
 * Extracted from the table so any surface offering the VAT cell (the table
 * column, the VAT review dialog) drives it through the exact same mutation and
 * rollback path instead of reimplementing it.
 */
export const useToggleVatMargin = (dealId: string) => {
  const updateField = useUpdateDealItemField(dealId);

  return useCallback(
    async (id: string) => {
      await updateField(id, {
        patch: (item) => ({ hasVatMargin: !item.activeVersion.hasVatMargin }),
        errorContext: 'handleVatMargin',
      });
    },
    [updateField]
  );
};
